export default __webpack_public_path__ + "b28c2eca12fe13230c75cd4ed6c49eb4.woff";